function config () {
  return window.__vera || {}
}

export function veraEnabled () {
  return Boolean(config().enabled)
}

export function conversationsPath () {
  return config().conversationsPath || '/vera/conversations'
}

export function hasResumable () {
  return Boolean(config().hasResumable)
}

export function isTradeBuyer () {
  return Boolean(config().tradeBuyer)
}

// Falls back to the key, so a missing label is visible and not blank.
export function t (key, replacements = {}) {
  const value = key.split('.').reduce((node, part) => (node ? node[part] : undefined), config().t)
  if (typeof value !== 'string') return key

  return Object.keys(replacements).reduce(
    (text, name) => text.replace(`%{${name}}`, replacements[name]),
    value
  )
}

export function pluralT (key, count) {
  return t(`${key}.${count === 1 ? 'one' : 'other'}`, { count })
}
